import { render, staticRenderFns } from "./NavigationMailbox.vue?vue&type=template&id=0309204f&scoped=true"
import script from "./NavigationMailbox.vue?vue&type=script&lang=js"
export * from "./NavigationMailbox.vue?vue&type=script&lang=js"
import style0 from "./NavigationMailbox.vue?vue&type=style&index=0&id=0309204f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0309204f",
  null
  
)

export default component.exports